import React from 'react';
import LoadingAsyncTask from 'components/loading/async-task';

export default function AsyncStorefrontStatus({ storefront, onCompleted }) {
  return (
    <LoadingAsyncTask
      record={storefront}
      onCompleted={onCompleted}
      endpoint="storefronts"
      tasks={[
        { type: 'install', label: 'Installing' },
        { type: 'update', label: 'Updating' },
        { type: 'publish', label: 'Publishing' },
      ]}
    />
  );
}
